import ICatalogItem from "./ICatalogItem";

class Catalog {

  public static instance: Catalog | null = null;

  private mPath: string;
  private mItems: ICatalogItem[];

  public constructor(path: string) {
    this.mPath = path;
    this.mItems = [];
  }

  public request(): Promise<string | void> {
    return fetch(this.mPath)
      .then((response: Response) => response.json())
      .then((json: ICatalogItem[]) => {
        this.mItems = json;

        return new Promise<string>(
          (resolve, reject) => {
            resolve("Fetching Catalog items ready!");
            reject("Fetching Catalog items failed!");
          },
        );
      })
      .catch((error: any) => {
        console.error("Error loading JSON:", error);
      });
  }

  public findByID(id: number): ICatalogItem | null {
    // Search recursively through the catalog items for the item with the specified ID
    const search = (items: ICatalogItem[]): ICatalogItem | null => {
      for (const item of items) {
        if (item.ID === id) {
          return item;
        }
        const foundInChildren = search(item.Children?[] : []);
        if (foundInChildren) {
          return foundInChildren;
        }
      }
      return null;
    };

    return search(this.mItems);
  }

  /**
   * Finds the category path (list of CategoryIDs) leading to a product with the given ID.
   * Returns the CategoryIDs of all ancestor categories so they can be auto-expanded.
   * Returns an empty array if the product is not found.
   */
  public findCategoryPathByProductId(productId: number): number[] {
    const path: number[] = [];

    const search = (items: ICatalogItem[]): boolean => {
      for (const item of items) {
        if (item.ID === productId && !item.Children) {
          return true;
        }

        if (item.Children && item.Children.length > 0) {
          path.push(item.CategoryID);
          if (search(item.Children)) {
            return true;
          }
          path.pop();
        }
      }
      return false;
    };

    search(this.mItems);
    return path;
  }

  public first(): ICatalogItem | null {
    const first = this.mItems[0];
    return (first ? first : null);
  }

  public children(): ICatalogItem[] {
    return Object.values(this.mItems);
  }
}

export default Catalog;
